import Cookies from 'js-cookie';
document.addEventListener("DOMContentLoaded", function () {
  loadBanner();
}); //loading header login via Ajax for Fastly

function loadBanner() {
  var nobanner = Cookies.get('nobanner');

  if (!nobanner) {
    var xhr = new XMLHttpRequest();
    var url = ajax_object.ajax_url;
    var data = 'action=load_banner';
    xhr.open('POST', url, true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 400) {
        var result = xhr.responseText;
        document.body.insertAdjacentHTML('afterbegin', result);
        var notificationBanner = document.getElementById('notificationBanner');

        if (notificationBanner) {
          var bannerHeight = notificationBanner.offsetHeight; // Set negative margin top equal to the height of the banner

          notificationBanner.style.marginTop = -bannerHeight + 'px'; // Trigger the sliding effect after a small delay

          setTimeout(function () {
            notificationBanner.classList.add('active');
          }, 10);
        }
      } else {
        console.log('Error: ' + xhr.statusText);
      }
    };

    xhr.onerror = function () {
      console.log('Network error');
    };

    xhr.send(data);
  }
} //on click of the close banner X


document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener('click', function (event) {
    if (!event.target.matches('#closeBanner')) return;
    event.preventDefault();
    var banner = document.getElementById('notificationBanner');

    if (banner) {
      if (banner.classList.contains('active')) {
        banner.classList.remove('active');
        Cookies.set('nobanner', 'true'); //SESSION COOKIE as expiration not set
      }
    }
  }, false);
});